const IconTag = (props) => {
    return (
        <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="35" height="25" viewBox="0 0 30 30" fill="none" stroke="#486f88">
            <g id="Group_104" data-name="Group 104" transform="translate(-772.642 -589.238)">
                <path id="Path_134" data-name="Path 134" d="M404.423,196.044,393.9,206.566a2.934,2.934,0,0,1-4.15,0h0l-12.605-12.591V179.3h14.674l12.606,12.605A2.936,2.936,0,0,1,404.423,196.044Z" transform="translate(396.249 410.688)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                <line id="Line_32" data-name="Line 32" transform="translate(780.728 597.325)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
            </g>
        </svg>

    )
}

export default IconTag;